import { type OpenApiSchemaPromocodeGroup } from '#shared/api/schema';
import { PROMOACTIONS_STATUSES_LIST } from './constants';

export function isPromoactionStatus(status: string): status is OpenApiSchemaPromocodeGroup['status'] {
    return PROMOACTIONS_STATUSES_LIST.includes(status as OpenApiSchemaPromocodeGroup['status']);
}
